export default __webpack_public_path__ + "static/media/gallery-wip-paint_04.3548e88b.jpg";